<template>
	<div id="main-menu" v-show="isOpen" ref="main-menu">
		<span id="menu-overlay" @click="close()"></span>
		<transition name="fade">
			<div id="menu-wrapper" v-show="isOpen" ref="menu-wrapper">
				<header id="menu-header">
					<span id="menu-close" class="link-icon" tabindex="0" @click="close()">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="A" d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z"/><path class="B" d="M0 0h24v24H0z"/></svg>
					</span>
					<div class="container">
						<div class="content">
							<router-link to="/" id="logo">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 60"><path class="A" d="M264 0H31.2c-16.6 0-30 13.4-30 30s13.4 30 30 30h196c2.6-.1 5-1.4 6.4-3.6L266 3.6s2.2-3.6-2-3.6z"/><path class="B" d="M55.5 27.7H33.1l-4.6 4.6h10.9c-1.3 4.7-6.1 7.5-10.9 6.3-4.7-1.3-7.5-6.1-6.3-10.9 1.3-4.7 6.1-7.5 10.9-6.3 1.5.4 2.9 1.2 4 2.3l3.3-3.3a13.46 13.46 0 0 0-19.1 0 13.46 13.46 0 0 0 0 19.1 13.46 13.46 0 0 0 19.1 0c2-2 3.3-4.5 3.8-7.2h6.7c-1.3 11-11.2 18.9-22.2 17.7-11-1.3-18.9-11.2-17.7-22.2 1.3-11 11.2-18.9 22.2-17.7 4.5.5 8.7 2.5 11.9 5.7l3.3-3.3c-9.6-9.6-25.3-9.6-34.9 0s-9.6 25.3 0 34.9 25.2 9.7 34.9 0c4.6-4.6 7.2-10.9 7.2-17.5v-2.2zm18 8.8h-3.7v18.3h-6.2V17.4c0-6.4 3.7-10.1 9.9-10.1s9.9 3.7 9.9 10.1v8.9c.1 6.2-2.8 10.2-9.9 10.2zm3.8-18.8c0-3.3-1.4-4.8-3.7-4.8s-3.7 1.5-3.7 4.8v13.1h3.7c2.6 0 3.8-1.9 3.8-4.8v-8.3zm20.2 37.7c-6.2 0-10.1-3.7-10.1-10.1V17.4c0-6.4 3.9-10.1 10.1-10.1s10.1 3.7 10.1 10.1v27.9c0 6.4-3.9 10.1-10.1 10.1zm3.9-37.7c0-3.3-1.6-4.8-3.9-4.8s-3.9 1.5-3.9 4.8V45c0 3.3 1.6 4.8 3.9 4.8s3.9-1.5 3.9-4.8V17.7zm24.9 37.1V39c0-3-1.2-4.8-3.8-4.8h-3.4v20.7h-6.2V17.4c0-6.4 3.7-10.1 9.9-10.1s9.7 3.7 9.7 10.1v6.8c0 3.2-1.7 5.9-3.9 7.1 2.6 1.1 3.9 4.2 3.9 7.8v15.8h-6.2zm0-37.1c0-3.3-1.2-4.8-3.5-4.8s-3.7 1.5-3.7 4.8V29h3.4c2.6 0 3.8-1.9 3.8-4.8v-6.5zm21.6-4.1v41.3h-6.2V13.6h-6.8V7.9h19.7v5.7h-6.7zm23 41.2V37h-7.2v17.9h-6.2V17.4c0-6.2 3.6-10.1 9.8-10.1s9.8 3.9 9.8 10.1v37.4h-6.2zm0-37.1c0-3.2-1.3-4.8-3.6-4.8s-3.6 1.7-3.6 4.8v13.6h7.2V17.7zm21.7 37.1c-7.1 0-9.9-4-9.9-10.2V7.9h6.2v36.4c0 3 1.2 4.8 3.8 4.8h5.4v5.8h-5.5z"/></svg>
							</router-link>
							<p class="sub-title"><!-- 
								{{$t('app-subtitle1')}}<br>
								{{$t('app-subtitle2')}}<br>
								{{$t('app-subtitle3')}} -->
							</p>
						</div>
					</div>
				</header>
				<section id="menu-content">
					<div class="container">
						<div class="content">
							<ul class="menu-items menu-primary">
								<li class="menu-item">
									<router-link :to="{name: 'customers'}">
										<svg class="menu-item-icon primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M16 11c1.66 0 3-1.34 3-3s-1.33-3-3-3-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 3-1.34 3-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0a11.68 11.68 0 0 0-.97.05C16.2 13.9 17 15.02 17 16.5V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>
										{{$t('customers')}}
									</router-link>
								</li>
								<li class="menu-item">
									<router-link :to="{name: 'machines'}">
										<svg class="menu-item-icon primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z"/></svg>
										{{$t('machines')}}
									</router-link>
								</li>
								<li class="menu-item">
									<router-link :to="{name: 'machine-types'}">
										<svg class="menu-item-icon primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M4 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 1 0 0-3zm0-6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 1 0 0-3zm0 12c-.83 0-1.5.68-1.5 1.5A1.51 1.51 0 0 0 4 19.5 1.51 1.51 0 0 0 5.5 18c0-.82-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"/></svg>
										{{$t('machine-types')}}
									</router-link>
								</li>
								<li class="menu-item">
									<router-link :to="{name: 'documents'}">
										<svg class="menu-item-icon primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14 2H6c-1.1 0-2 .9-2 2V20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/></svg>
										{{$t('documents')}}
									</router-link>
								</li>
							</ul>
							<div class="boxed">
								<span class="title boxed-title customer-area" v-if="userLogged">
									<router-link :to="{name: 'home'}">{{username}}</router-link>
									<a href="#" @click.prevent="logout">{{$t('exit')}}</a>
								</span>
								<span class="title boxed-title customer-area" v-else>
									{{$t('users-area')}}
									<router-link :to="{name: 'login'}">{{$t('enter')}}</router-link>
								</span>
								<ul class="menu-items boxed-item">
									<li class="menu-item">
										<router-link :to="{name: 'users'}">
											<svg class="menu-item-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22"><path d="M5.5,5.5A5.5,5.5,0,1,1,11,11,5.5,5.5,0,0,1,5.5,5.5ZM0,22V19.25c0-3,5-5.5,11-5.5s11,2.48,11,5.5V22Z"/></svg>
											{{$t('users')}}
										</router-link>
									</li>
								</ul>
							</div>
							<ul class="menu-items">
								<li class="menu-item">
									<router-link :to="{name: 'home'}">
										<svg class="menu-item-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 100"><path d="M74 100H2a2 2 0 0 1-2-2V82a37.39 37.39 0 0 1 27.27-35.69 24.4 24.4 0 1 1 21.47 0A37.39 37.39 0 0 1 76 82v16a2 2 0 0 1-2 2zM4 96h68V82c0-18.3-15.25-33.2-34-33.2S4 63.7 4 82zM38 4a20.4 20.4 0 1 0 20.4 20.4A20.42 20.42 0 0 0 38 4z"/></svg>
										{{$t('account')}}
									</router-link>
								</li>
								<li class="menu-item">
									<router-link to="/settings">
										<svg class="menu-item-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000"><path d="M578 980.7H420.6L395 823c-16.5-5.4-32.7-12.2-48.2-20l-131 95.4L104.4 787l95.3-131c-8-16-15-32.4-20.5-49.3l-160-25.2V424l160-25.2c5.6-17.2 12.6-34 21-50.3l-96.5-132.6L215 104.4l133.4 97c15-7.5 30.5-14 46.4-19.2l25.6-163H578L603.6 182c16.6 5.4 33 12 48.7 20l132-95 111.3 111.3-95 131.8c7.8 15.3 14.4 31.3 19.8 47.6l160.3 26v157.5l-160.3 26c-5.2 16-11.7 31.6-19.2 46.6L895 784.2 783.6 895.6l-129.4-93.2c-16.3 8.4-33.2 15.4-50.5 21L578 980.7zm-148-11h138.7L594 815l3.3-1c18.8-6 37.3-13.6 55-23l3-1.6L782.4 881l98-98-89.2-124-3.2-3.2 1.8-3.6c8.6-16.6 15.7-34 21.3-51.7l1.2-4h6L969.7 572V433.3l-151-24.6h-6.5l-1.2-4c-5.7-18.2-13-36-22-53l-2-3.6 4.3-4.3L881 219.5l-98-98-124 89.3-4.6 4.6-3.6-2c-17.2-9-35.3-16.5-53.6-22.2l-3.3-1-25.2-160H430L405.5 187v3.6l-3.8 1.2c-17.5 5.5-34.7 12.7-51 21l-3.6 2-2.8-2.8-128-93-98 98 95 130.5-1.6 3c-9.3 17.5-17 36-22.8 54.8l-1 3.3-157.5 24.7V572l157.4 24.8 1 3.3c5.8 18.4 13.3 36.5 22.3 53.8l1.6 3-93.8 129 98 98 129-93.8 3 1.6c17 9 34.6 16.3 52.7 22l4 1.2v3.6L430 969.7z"/><path d="M586 990H412.7l-26-160c-13.2-4.6-26.4-10-39-16.3l-132.8 96.7L92.2 788 189 655c-6.4-13-12-26.5-16.6-40.2L10 589.3V416l162.3-25.6c4.8-14 10.5-27.8 17.2-41.2l-98-134.4L214 92.2l135.3 98.4c12-5.8 24.6-11 37.2-15.4l26-165.3H586l26 164.8c13.4 4.6 26.7 10 39.6 16.3l133.7-96.2 122.4 122.4L811.4 351c6 12.5 11.5 25.4 16 38.5L990 416v173.2l-162.6 26.5c-4.4 12.7-9.6 25.3-15.5 37.5l95 132-122.4 122.4-131.2-94.5C640 820 626 825.7 612 830.5L586 990zm-148-29.6h123l25-152.6 8.8-2.7c18.3-5.7 36.2-13.2 53.4-22.2l8-4.2L781.6 869l87-87-87-120-4.8-4.8 5-9.6c8.3-16 15.3-33 20.7-50.3l3.2-10.4h12.8l142-23.2V441.2L817.2 418H805.4l-3.3-10.4c-5.5-17.7-12.7-35-21.3-51.4l-5-9.6 9-9 84-117-87-87L661 222 656 227l-9.6-5c-16.7-8.8-34.3-16-52-21.6l-8.8-2.7-25-158H438l-23.4 148.8.1 9-10.3 3.3c-17 5.4-33.7 12.3-49.6 20.5l-9.6 5-7.6-7.6L217.2 131l-86.8 86.8 93.8 128.8-4.3 8c-9 17-16.5 35-22.2 53.2l-2.7 8.8-155.4 24.5V564L195 588.4l2.7 8.8c5.6 18 13 35.5 21.7 52.3l4.3 8L131 784.8l86.8 86.8L345 779l8 4.2c16.4 8.6 33.6 15.8 51.2 21.4l10.3 3.3v10.4l23.3 142zm61.5-260c-109.7 0-199-89.2-199-199s89.2-199 199-199 199 89.2 199 199c.1 109.6-89.2 199-199 199zm0-387c-103.6 0-188 84.3-188 188s84.3 188 188 188 188-84.3 188-188-84.3-188-188-188zm0 396c-114.8 0-208.2-93.4-208.2-208.2s93.4-208.2 208.2-208.2 208.2 93.4 208.2 208.2-93.4 208.2-208.2 208.2zm0-386.8c-98.5 0-178.6 80-178.6 178.6S401 680 499.4 680 678 600 678 501.5C678 403 598 323 499.4 323z"/></svg>
										{{$t('settings')}}
									</router-link>
								</li>
							</ul>
							<div class="info">{{currentYear}} &copy; hivetechnology.net <span class="version">{{version}}</span></div>
						</div>
					</div>
				</section>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'MainMenu',
	methods: {
		close() {
			this.$store.dispatch('closeMenu');
		},
		logout () {
			let self = this;
			self.$store.dispatch('authLogout')
			.then(() => {
				self.$router.push({name: 'login'});
			});
		},
	},
	computed: {
		isOpen() {
			return this.$store.getters.isMenuOpen;
		},
		currentYear() {
			return (new Date()).getFullYear();
		},
		username() {
			return this.$store.getters.getProfile.name;
		},
		userLogged() {
			return this.$store.getters.isAuthenticated;
		},
		version() {
			return `${process.env.VUE_APP_VERSION}`;
		}
	},
	watch: {
		isOpen(newValue) {
			let scrollParent = getScrollParent(this.$refs['main-menu']);
			let top = 0;
			if (scrollParent) {
				scrollParent.style.overflow = newValue?'hidden':'auto';
				top = scrollParent.scrollTop;
			}
			this.$refs['menu-wrapper'].scrollTop = 0;
			this.$refs['menu-wrapper'].style.top = top + 'px';
		},
		$route(to, from) {
			this.$store.dispatch('closeMenu');
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#main-menu #menu-overlay {
	position: fixed;
	display: block;
	top: 0;
	right: 0;
	width: 100%;
	height: 100%;
	margin: 0;
	background-color: rgba(0,0,0,0.5);
	z-index: 200;
}

#main-menu #menu-wrapper {
	position: absolute;
	top: 0;
	right: 0;
	width: 36.0rem;
	max-width: 100%;
	height: 100%;
	background-color: #fff;
	z-index: -1;
	box-shadow: /*-4.0rem 0 0 0 rgba(0,0,0,0.2),*/
	0 0 0.4rem rgba(0,0,0,0.5);
	overflow: auto;
	color: var(--primary_text_color);
	z-index: 300;
	transition: opacity .2s ease-in-out;
}

#main-menu #menu-header {
	background-color: var(--primary_color_darker);
	color: var(--inverse_text_color);
	padding-top: 7.2rem;
}

#main-menu #menu-header path {
	fill: var(--inverse_text_color);
}

#main-menu #menu-close {
	position: absolute;
	top: 1.6rem;
	right: 2.0rem;
	z-index: 30;
	color: var(--inverse_text_color);
}

#main-menu #menu-close svg {
	width: 100%;
	height: 100%;
}

#main-menu #menu-close .B {
	fill: none;
}

#main-menu #menu-header #logo {
	display: flex;
	color: var(--inverse_text_color);
}

#main-menu #menu-header #logo svg {
	width: auto;
	height: 8.0rem;
}

/*#main-menu #menu-header #logo .A {
	fill: var(--inverse_text_color);
}*/

#main-menu #menu-header #logo .B {
	fill: var(--primary_color);
}

/*#main-menu #menu-header #logo .C {
	fill: var(--inverse_text_color);
}*/

#main-menu #menu-header .sub-title {
	font-family: 'Charlet Comprime';
	font-size: 3.2rem;
	line-height: 3.2rem;
	font-weight: 500;
	padding: 2.4rem 0 5.6rem 0;
}

#main-menu #menu-content path {
	fill: var(--primary_text_color);
}

#main-menu #menu-content .primary path {
	fill: var(--primary_color);
}

#main-menu #menu-content .menu-items {
	flex-basis: 100%;
	list-style: none;
	margin: 0 0 2.4rem 0;
}

#main-menu #menu-content .menu-items .menu-item {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: .8rem;
	overflow: hidden;
}

#main-menu #menu-content .menu-items .menu-item a {
	display: flex;
	font-size: 2.0rem;
	line-height: 4.0rem;
	color: var(--primary_text_color);
}

#main-menu #menu-content .menu-items.menu-primary .menu-item,
#main-menu #menu-content .menu-items.menu-primary .menu-item a {
	color: var(--primary_color_darker);
}

#main-menu #menu-content .menu-items .menu-item .menu-item-icon {
	display: block;
	width: 4.0rem;
	height: 4.0rem;
	margin-right: 1.6rem;
}

#main-menu #menu-content .menu-items .menu-item .menu-item-icon.small {
	padding: .4rem;
}

#main-menu #menu-content .title {
	display: block;
	text-align: center;
	font-size: 1.8rem;
	margin-bottom: 1.6rem;
}

#main-menu #menu-content .menu-items .menu-item .menu-item-label {
	display: flex;
	align-items: center;
	cursor: pointer;
	margin-bottom: 0;
	margin-left: .8rem;
}

#main-menu #menu-content .menu-items .menu-item .menu-item-checkbox {
	display: none;
}

#main-menu #menu-content .menu-items .menu-item .menu-items {
	max-height: 0;
	position: absolute;
	margin-bottom: 0;
	padding: 1.6rem;
	border-left: .3rem solid var(--primary_color_darker);
	opacity: 0;
	pointer-events: none;
}

#main-menu #menu-content .menu-items .menu-item .menu-item-checkbox:checked ~ .menu-items {
	max-height: 500px;
	position: inherit;
	opacity: 1;
	pointer-events: auto;
	transition: opacity .2s ease-in-out, max-height .5s ease-in-out;
}

#main-menu #menu-content .menu-items .menu-item .dropdown-icon {
	width: 2.0rem;
	height: 2.0rem;
	transform: rotate(270deg);
	transition: transform .2s ease-in-out;
}

#main-menu #menu-content .menu-items .menu-item .menu-item-checkbox:checked ~ .menu-item-label .dropdown-icon {
	transform: rotate(90deg);
}

#main-menu .credits {
	position: absolute;
	bottom: 0;
	margin-bottom: 0;
	font-size: 1.8rem;
}

#main-menu .credits .credits-link {
	background: var(--inverse_text_color);
	color: var(--primary_color);
	border-radius: .3rem;
	padding: 0 .3rem;
}

#main-menu .info {
	display: flex;
	justify-content: space-between;
	margin-bottom: .8rem;
}

#main-menu #menu-content .boxed .boxed-title {
	background: #ddd;
	border-radius: .3rem;
	padding: 0 .8rem;
	margin-bottom: 0;
}

#main-menu #menu-content .boxed .boxed-title.customer-area {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

#main-menu #menu-content .boxed .boxed-item {
	background: #ececec;
	padding: 1.6rem 0.8rem 0.8rem 0.8rem;
	border-radius: .3rem;
}

#main-menu .link-icon {
	width: 4.0rem;
	height: 4.0rem;
}
</style>
